import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { errText } from "../lib/api";
import StellaLogo from "../components/StellaLogo";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) return toast.error("Password must be at least 10 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Please sign in.");
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(errText(err, "Invalid or expired token"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F5] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center text-indigo-700 mb-6">
          <StellaLogo className="w-8 h-8" />
          <span className="text-2xl font-extrabold tracking-tight text-slate-900">Stella</span>
        </div>
        <div className="bg-white border border-[#E5E4DE] rounded-2xl shadow-[0_2px_12px_rgba(15,23,42,0.04)] p-6 sm:p-8">
          <h1 className="text-xl font-bold text-slate-900">Set a new password</h1>
          <form onSubmit={submit} className="mt-5 space-y-3">
            <div>
              <label className="text-xs font-medium text-slate-600">Reset token</label>
              <Input required value={token} onChange={(e) => setToken(e.target.value)}
                     data-testid="reset-token" className="mt-1 h-11" />
            </div>
            <div>
              <label className="text-xs font-medium text-slate-600">New password (min 10 chars)</label>
              <Input type="password" required value={password}
                     onChange={(e) => setPassword(e.target.value)}
                     data-testid="reset-password" className="mt-1 h-11" />
            </div>
            <div>
              <label className="text-xs font-medium text-slate-600">Confirm new password</label>
              <Input type="password" required value={confirm}
                     onChange={(e) => setConfirm(e.target.value)}
                     data-testid="reset-confirm" className="mt-1 h-11" />
            </div>
            <Button type="submit" disabled={submitting} data-testid="reset-submit"
                    className="w-full h-11 bg-indigo-700 hover:bg-indigo-800 text-white rounded-xl">
              {submitting ? "Updating..." : "Reset password"}
            </Button>
            <div className="text-center">
              <Link to="/login" className="text-xs text-indigo-700 hover:text-indigo-900">← Back to sign in</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
